import { gql } from '@apollo/client'
import { PRODUCT_FRAGMENT } from '../fragments/product'

const CategoryFragment = `
    id
    name
    description
`

export const QUERY_GET_STORE_CATEGORIES = gql`
  query Categories(
    $id: UUID
    $slug: String
    $fulfillmentDatetime: UTCTimestamp
    $fulfillmentType: FulfillmentType
  ) {
    store(id: $id, slug: $slug) {
      categories(
        fulfillmentDatetime: $fulfillmentDatetime
        fulfillmentType: $fulfillmentType
      ) {
        ${CategoryFragment}
        products {
          ${PRODUCT_FRAGMENT}
        }
      }
    }
  }
`
